export const cardDescription = {
  agencies: 'Add or update basic Agency information.',
  procedureCodes: 'Configure and display the Procedure Codes provided by the aggregator.',
  reasonCodes: 'Configure and display the Reason Codes provided by the aggregator.',
  payers: 'Display the Payers provided by the aggregator.',
  resolutionCodes: 'Configure and display the Resolution Codes provided by the aggregator.',
  taskCodes: 'Configure and display the Task Codes provided by the aggregator.',
  requiredFields: 'Configure and display the special required fields for an aggregator.',
  exceptionCodes: 'Configure and display the Exception Codes provided by the aggregator.',
};
